var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDateIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_160127",
    "data-name": "Group 160127",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_140007",
    "data-name": "Rectangle 140007",
    width: 18,
    height: 18,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "calendar-outline",
    transform: "translate(2 2.029)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_140006",
    "data-name": "Rectangle 140006",
    width: 14,
    height: 13,
    rx: 2,
    transform: "translate(0 0.941)",
    fill: "none",
    stroke: "#a4a5aa",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_54",
    "data-name": "Ellipse 54",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(8 4.941)",
    fill: "#a4a5aa"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_55",
    "data-name": "Ellipse 55",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(11 4.941)",
    fill: "#a4a5aa"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_56",
    "data-name": "Ellipse 56",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(8 7.941)",
    fill: "#a4a5aa"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_57",
    "data-name": "Ellipse 57",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(11 7.941)",
    fill: "#a4a5aa"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58",
    "data-name": "Ellipse 58",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(2 7.941)",
    fill: "#a4a5aa"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_59",
    "data-name": "Ellipse 59",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(5 7.941)",
    fill: "#a4a5aa"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_60",
    "data-name": "Ellipse 60",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(2 10.941)",
    fill: "#a4a5aa"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_61",
    "data-name": "Ellipse 61",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(5 10.941)",
    fill: "#a4a5aa"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_62",
    "data-name": "Ellipse 62",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(8 10.941)",
    fill: "#a4a5aa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83089",
    "data-name": "Path 83089",
    d: "M128,48v1.069M136.552,48v1.069",
    transform: "translate(-125.276 -48)",
    fill: "none",
    stroke: "#a4a5aa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83090",
    "data-name": "Path 83090",
    d: "M61.9,160H48",
    transform: "translate(-47.949 -156.258)",
    fill: "none",
    stroke: "#a4a5aa",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDateIcon);
export default __webpack_public_path__ + "static/media/date-icon.7d650ad6c200f2d159a1145cd41ae7b3.svg";
export { ForwardRef as ReactComponent };